export const CONTACT_URL = "https://wsafeai.com/contact";
export const PRICING_URL = "https://wsafeai.com/pricing";
export const SIGNIN_URL = "https://wsafe.si";

export const PILOT_URL = CONTACT_URL;
export const HUB_URL = "https://worksafeagent.com";
export const HUB_PRICING_URL = "https://worksafeagent.com/pricing";

const ICON_BASE = "https://wsafeai.github.io/wsafeai-procore-prototype/brand/products";
const icon = (folder) => `${ICON_BASE}/${folder}/${folder}-32.png`;

export const PRODUCTS = [
  { name: "WSafe AI", url: "https://wsafe.ai", icon: icon("wsafe-ai"), desc: "AI hazard detection on existing cameras" },
  { name: "HazardLoop", url: "https://hazardloop.com", icon: icon("hazardloop"), desc: "Corrective action tracking and verified closeout" },
  { name: "InductIQ", url: "https://inductiq.ai", icon: icon("inductiq"), desc: "Induction/training verification and incident reporting" },
  { name: "EnviSafe", url: "https://envisafe.ai", icon: icon("envisafe"), desc: "Environmental conditions monitoring" },
  { name: "SafeForm", url: "https://safeform.ai", icon: icon("safeform"), desc: "Ergonomic analysis", current: true },
  { name: "WorkSafeStory", url: "https://worksafestory.com", icon: icon("worksafestory"), desc: "Safety stories and lessons learned" },
];

export const NAV_EXTRA = [
  { name: "Pricing", url: PRICING_URL },
  { name: "Services", url: "https://wsafeai.com/services" },
  { name: "Contact", url: CONTACT_URL },
];

export const FOOTER_LINKS = [
  { name: "Pricing", url: PRICING_URL },
  { name: "Compliance Service", url: "https://wsafeai.com/services" },
  { name: "Consulting", url: "https://wsafeai.com/services" },
  { name: "Privacy", url: "https://wsafeai.com/privacy" },
  { name: "Terms", url: "https://wsafeai.com/terms" },
  { name: "Contact (info@wsafeai.com)", url: CONTACT_URL },
];

export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "");
